import { render, staticRenderFns } from "./DatasetSelector.vue?vue&type=template&id=8e8ed0e8"
import script from "./DatasetSelector.vue?vue&type=script&lang=ts"
export * from "./DatasetSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports